/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F4_AInputs */

const en_mk_sec_pg_f4_a = /** @type {(inputs: Mk_Sec_Pg_F4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workspace drops to the Free plan and stays open; nothing is deleted automatically. If you want the data gone, delete the workspace in Settings.`)
};

const id_mk_sec_pg_f4_a = /** @type {(inputs: Mk_Sec_Pg_F4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace turun ke paket Gratis dan tetap bisa dibuka; tidak ada yang dihapus otomatis. Kalau Anda ingin data hilang sepenuhnya, hapus workspace lewat Pengaturan.`)
};

/**
* | output |
* | --- |
* | "The workspace drops to the Free plan and stays open; nothing is deleted automatically. If you want the data gone, delete the workspace in Settings." |
*
* @param {Mk_Sec_Pg_F4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f4_a = /** @type {((inputs?: Mk_Sec_Pg_F4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f4_a(inputs)
	return en_mk_sec_pg_f4_a(inputs)
});